import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Theme from './theme';
export var TabGroupTheme = Theme;
/*::
import type { Node } from 'react';
import type { TabsGroupThemeType } from './theme';

type TabGroupPropsType = {|
  children?: Node,
  theme?: TabsGroupThemeType,
  rest?: any,
|};
*/

var TabGroup = function TabGroup(_ref
/*: TabGroupPropsType */
) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "theme"]);

  return /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    "data-test": "tabs-group-main"
  }, rest), children);
};

export default TabGroup;